export default class EsayInfo {
	constructor() {
		this.num = 0
		this.id = "99u8239"
		this.appCode = process.env.VUE_APP_CODE
		this.data = {
			appCode:process.env.VUE_APP_CODE
		}
	}
	add(val,type) {
		if( type ){
			if( type && type == "list" ){
				this.data['data_'+this.num] = val
				this.num++;
			}
			if( type && type == "obj" ){
				this.data['data_'+this.num] = val
				this.num++;
			}
		}else{
			this.data['param_'+this.num] = val
			this.num++;
		}
	}
}